import { Component, Input, inject, signal } from '@angular/core';
import { UserService } from '../../service/user.service';
import { ProductService } from '../../service/product.service';
import { PlanthunterService } from '../../service/planthunter.service';
import { Planthunter } from '../../classes/planthunter';
import { WindowRef } from '../../service/window-ref.service';
import { Router } from '@angular/router';
import { ApplicationService } from '../../service/application.service';
import { LocationStrategy } from '@angular/common';
import { PlanthunterOverviewGridComponent } from './planthunter.overview.grid.component';

@Component({
    selector: 'planthunter-overview-component',
    templateUrl: './planthunter.overview.component.html',
    styleUrls: ['planthunter.component.scss'],
    standalone: true,
    imports: [PlanthunterOverviewGridComponent]
})
export class PlanthunterOverviewComponent {
  private planthunterService = inject(PlanthunterService);
  private applicationService = inject(ApplicationService);
  private locationStrategy = inject(LocationStrategy);
  private productService = inject(ProductService);
  private router = inject(Router);

  private static winRef: WindowRef = new WindowRef();
  private initialAmountOfProducts: number = 5;

  showAllProductsForHunter: string | null;
  @Input() planthunterDetailURL: string;
  private _userService: UserService;

  readonly planthunters = signal<Planthunter[]>([]);

  constructor() {
    const userService = inject(UserService);

    this._userService = userService;

    this.planthunterService
      .getPlanthunters(this.initialAmountOfProducts)
      .then((planthunter) => {
        this.planthunters.set(planthunter);
        const hunterFeature = this.getParameterByName('hunter', null);

        if (hunterFeature !== null && hunterFeature !== '') {
          this.showAllProductsForHunter = hunterFeature;
        }
      });
  }

  isUserLoggedin(): boolean {
    return this._userService.isLoggedIn();
  }

  /**
   * Decides if the link to the Hunter Detail page should be done by the Angular Routers (webshop) or
   * by setting the location and pushing the state (Website).
   *
   * This way the hunters on the KvK shop do not trigger a full page refresh since the whole shop is an
   * Angular application. This is not the case for the website.
   *
   * @param planthunter - Planthunter Object
   */
  gotoHunterDetail(planthunter: Planthunter): void {
    if (this.applicationService.isBrowsingWebsite(window.location.href)) {
      this.locationStrategy.pushState(
        { plantHunterId: planthunter.planthunterFeature },
        'Hunter Detail',
        this.getPlantHunterDetailPageURL(planthunter),
        ''
      );
      PlanthunterOverviewComponent.winRef.nativeWindow.location.href =
        this.getPlantHunterDetailPageURL(planthunter);
      return;
    }

    this.router.navigate([
      this.planthunterDetailURL,
      {
        plantHunterId: planthunter.planthunterFeature
      }
    ]);
  }

  getPlantHunterDetailPageURL(planthunter: Planthunter): string {
    return `${this.planthunterDetailURL}?plantHunterId=${planthunter.planthunterFeature}`;
  }

  followPlanthunter(planthunter: Planthunter): void {
    this.planthunterService
      .followPlanthunter(planthunter.code)
      .then(() => (planthunter.volgStatus = true));
  }

  unfollowPlanthunter(planthunter: Planthunter): void {
    this.planthunterService
      .unfollowPlanthunter(planthunter.code)
      .then(() => (planthunter.volgStatus = false));
  }

  getParameterByName(name: string, url: string | null): string | null {
    if (!url) {
      url = window.location.href;
    }

    /* eslint-disable no-useless-escape */
    name = name.replace(/[\[\]]/g, '\\$&');

    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
